import React, { Component } from 'react';
import moment from 'moment';
import { Form, Mentions, TimePicker, Button, InputNumber, message } from 'antd';
import _ from 'lodash';

const FormItem = Form.Item;

class DetailedScheduleEditTimeForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            startTime: props.editValue.startTime,
            endTime: props.editValue.endTime,
            duration: props.editValue.endTime.diff(props.editValue.startTime, 'minutes') / 60,
            label: props.labelValue,
            tourTimes: props.tourTimes,
            tour: props.tour,
            changeTour: false
        }
    }

    validateForm = () => {
        const format = 'hh:ss a';

        let validationObject = {
            value: false,
            message: ''
        };

        const momentStart = moment(this.state.startTime, format);
        const momentEnd = moment(this.state.endTime, format);
        const momentTourStart = moment(this.state.tourTimes.startTime, format);
        const momentTourEnd = moment(this.state.tourTimes.endTime, format);
        // Added
        // const meals = this.state.tour.meals;
        // const assignments = this.state.tour.serviceOrders;

        switch (this.state.label) {
            case 'tourTimes': // Here
                validationObject.value = true;
                break;
            case 'mealTimes':
                if (
                    momentStart.isBetween(momentTourStart, momentTourEnd, undefined, '[]') &&
                    momentEnd.isBetween(momentTourStart, momentTourEnd, undefined, '[]')
                ) {
                    validationObject.value = true;
                    break;
                } else {
                    validationObject.message = 'Meals must be within the tour times.';
                    break;
                }
            case 'assignTimes':
                if (
                    ( momentStart.isBetween(momentTourStart, momentTourEnd, undefined, '[]') &&
                     momentEnd.isBetween(momentTourStart, momentTourEnd, undefined, '[]')
                    ) || !this.state.tourTimes.isApproved
                ) {
                    validationObject.value = true;
                    this.state.changeTour = true;
                    break;
                } else {
                    validationObject.message = 'Assignment times must be within the tour times.';
                    break;
                }
            default:
                break;
        }

        return validationObject;
    }

    handleSubmit = (e) => {
        e.preventDefault();

        const validation = this.validateForm();

        if (validation.value) {
            let returnValue = {
                timeStart: this.state.startTime,
                timeEnd: this.state.endTime,
                changeTour: this.state.changeTour
            };
            this.props.handleComponentEditSubmit(returnValue, this.state.label);
        } else {
            message.error(validation.message);
        }
    }

    handleStartTimeChange = (e) => {
        if (e) {
            if (this.state.label === 'mealTimes') {
                this.setStartTime(e);
            } else if (this.state.label === 'tourTimes') {
                this.setStartTime(e);
            } else if (this.state.label === 'assignTimes') {
                this.setStartTime(e);
            }
        }
    }

    handleEndTimeChange = (e) => {
        if (e) {
            if (this.state.label === 'mealTimes'
                && e.diff(this.state.tourTimes.endTime, 'minutes') / 60 <= 0
                && e.diff(this.state.startTime, 'minutes') / 60 > 0) {
                this.setEndTime(e);
            } else if (this.state.label === 'tourTimes' || this.state.label === 'assignTimes') {
                if (e.diff(this.state.startTime, 'minutes') / 60 <= 0) {
                    e.add(1, 'days');
                }
                this.setEndTime(e);
            } 
        }
    }

    handleDurationChange = (value) => {
        const roundedValue = this.roundToQuarters(value);
        
        let clonedStartTime = _.cloneDeep(this.state.startTime);
        if ((this.state.label === 'mealTimes' && roundedValue > 0 && clonedStartTime.add(roundedValue, 'hours').diff(this.state.tourTimes.endTime, 'minutes') / 60 <= 0)
            || (this.state.label === 'tourTimes' && value > 0 && value <= 168)
            || (this.state.label === 'assignTimes' && value > 0 && value <= 168) ) {
            this.setDuration(roundedValue);
        } else {
            this.setState({ duration: this.state.endTime.diff(this.state.startTime, 'minutes') / 60 });
        }

    }

    roundToQuarters = (input) => {
        if(/^\d+(\.\d+)?$/.test(input)){
            const number = parseFloat(input)
            const roundedNumber = Math.floor(number*4)/4;
            return roundedNumber;
        }
        return 0;
    }

    setStartTime = (e) => {
        this.setState({
            startTime: e
        }, () => {
            let clonedStartTime = _.cloneDeep(this.state.startTime);
            this.setState({ endTime: clonedStartTime.add(this.state.duration, 'hours') });
        });
    }

    setEndTime = (e) => {
        this.setState({
            endTime: e
        }, () => {
            let clonedEndTime = _.cloneDeep(this.state.endTime);
            this.setState({ duration: clonedEndTime.diff(this.state.startTime, 'minutes') / 60 });
        });
    }

    setDuration = (value) => {
        let clonedStartTime = _.cloneDeep(this.state.startTime);
        this.setState({
            duration: value,
            endTime: clonedStartTime.add(value, 'hours')
        });
    }

    handleCancel = () => {
        this.props.handleEditCancel();
    }


    render(props) {
        return (
            <Form onSubmit={this.handleSubmit}>
                <FormItem>
                    <div>
                        <Mentions
                            style={{ marginRight: 10, border: "none", width: 120 }}
                            defaultValue="Start Time"
                            readOnly
                        />
                        <TimePicker
                            label="Start Time"
                            format="h:mm a"
                            onChange={this.handleStartTimeChange}
                            value={this.state.startTime}
                            popupStyle={{ zIndex: 2000 }}
                            id="startTime"
                            allowClear={false}
                            use12Hours={true}
                            minuteStep={15}
                            inputReadOnly={true}
                        />
                    </div>
                </FormItem>
                <FormItem>
                    <div>
                        <Mentions
                            style={{ marginRight: 10, border: "none", width: 120 }}
                            defaultValue="End Time"
                            readOnly
                        />
                        <TimePicker
                            label="End Time"
                            format="h:mm a"
                            onChange={this.handleEndTimeChange}
                            value={this.state.endTime}
                            popupStyle={{ zIndex: 2000 }}
                            id="endTime"
                            allowClear={false}
                            use12Hours={true}
                            minuteStep={15}
                            inputReadOnly={true}
                        />
                    </div>
                </FormItem>
                <FormItem>
                    <div>
                        <Mentions
                            style={{ marginRight: 10, border: "none", width: 120 }}
                            defaultValue="Duration"
                            readOnly
                        />
                        <InputNumber
                            value={this.state.duration}
                            onChange={this.handleDurationChange}
                            popupStyle={{ zIndex: 2000 }}
                        />
                    </div>
                </FormItem>
                <FormItem>
                    <div>
                        <Button type='danger' onClick={this.handleCancel}>Cancel</Button>
                        <Button
                            type="primary"
                            htmlType="submit"
                            disabled={this.props.buttonDisable}
                        >Submit</Button>
                    </div>
                </FormItem>
            </Form>
        );
    }
}

export const WrappedDetailedScheduleEditTimeForm = Form.create()(DetailedScheduleEditTimeForm);



// WEBPACK FOOTER //
// ./src/Components/Schedule/DetailedSchedule/DetailedScheduleEditTimeForm.js